const estudioTurnosInitialState = {
  estudioTurnos: {
    loading: false,
    error: null,
    data: null,
    circuitoReso: {
      contraste: false,
      renal: false,
      peso: false,
      marcaPasos: false,
      diabetico: false,
      hipertenso: false,
      labFuncionRenal: false,
      implanteMetalico: false,
      materialImpMet: "",
      ubicacionImpMet: "",
      fechaImpMet: "",
      marcaMarcapasos: "",
      modeloMarcapasos: "",
      fechaMarcapasos: "",
      flgForm: false,
    },
    circuitoTomo: {
      pesoSuperior: false,
      pesoSuperiorCritico: false,
      conContraste: false,
      insRenal: false,
      diabeticoHipertenso: false,
      contrasteReciente: false,
      embarazada: false,
      amamantando: false,
      diabetico: false,
      hipertenso: false,
      labFuncionRenal: false,
      implanteMetalico: false,
      materialImpMet: "",
      ubicacionImpMet: "",
      fechaImpMet: "",
      marcaMarcapasos: "",
      modeloMarcapasos: "",
      fechaMarcapasos: "",
      flgForm: false,
    },
  },
};

export default estudioTurnosInitialState;
